import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export const useGetFormatedTime = () => {
  const { formatMessage } = useIntl();

  const getFormatedTime = useCallback((timestamp: number | string = 0) => {
    const hours = Math.floor(Number(timestamp) / 60 / 60);
    const minutes = Math.floor(Number(timestamp) / 60) % 60;
    return `${hours} ${formatMessage({ id: 'hours' })} ${minutes} ${formatMessage({ id: 'min' })}`;
  }, [ formatMessage ]);

  return getFormatedTime;
};
